<template>
  <div>
    <v-card>
      <v-card-title :style="backgroundStarStyle">
        <span class="headline black--text">Data importer</span>
        <v-spacer></v-spacer>
        <v-btn icon light class="m-0" @click="closeDialog()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="this.data !== null">
          <v-row no-gutters>
            <v-col p-2>
              <v-card>
                <v-list>
                  <v-list-item v-for="item in this.data" :key="item.value.id">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action p-2>
                      <v-btn
                        outlined
                        primary
                        v-on:click="importItem(item.value)"
                      >
                        Import
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'data-importer',
  data() {
    return {
      dialogState: false,
      data: null,
      itemType: null,
      availableRoutesTable: {
        OrbitDefinition: 'ParametricOrbitDefinition',
        ParametricOrbitDefinition: 'OrbitDefinition',
        ParametricSpacecraftDefinition: 'SpacecraftDefinition',
        SpacecraftDefinition: 'ParametricSpacecraftDefinition',
        ParametricPropulsionSystemDefinition: 'PropulsionSystemDefinition',
        PropulsionSystemDefinition: 'ParametricPropulsionSystemDefinition'
      }
    }
  },
  props: {
    root: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.itemType = this.root.root.getCurrentFormType()
    if (this.availableRoutesTable[this.itemType] != null) {
      this.loadData()
    }
  },
  computed: {
    ...mapGetters({ currentMission: 'currentMission' }),
    backgroundStarStyle() {
      return 'background: #3BE287'
    }
  },
  methods: {
    importItem(obj) {
      let self = this
      this.$http
        .get(
          this.root.root.getAPI(this.itemType + 's') + '/' + obj.id + '/convert'
        )
        .then((response) => {
          let item = response.data.data
          let log = response.data.log
          this.root.root.successAlertMessage = item.name
          this.root.root.tableItems.push(item)
          if (log && log.length > 0) {
            self.root.root.displayMessage(
              'Import Log',
              log.join(' - '),
              'notification',
              'success'
            )
          }
          if (
            this.itemType === 'ParametricSpacecraftDefinition' ||
            this.itemType === 'SpacecraftDefinition'
          ) {
            this.root.root.refreshReferences()
          }
        })
        .catch((e) => {
          self.root.root.displayMessage(
            `Error getting list of ${this.itemType}. `,
            e,
            'notification',
            'error'
          )
        })
      this.closeDialog()
    },
    refreshData(toLoad) {
      let self = this
      this.$http
        .get(this.root.root.getAPI(toLoad + 's'))
        .then((response) => {
          self.data = response.data.map((obj) => ({
            value: obj,
            text: obj.displayedName
          }))
        })
        .catch((e) => {
          self.root.root.displayMessage(
            `Error getting list of ${toLoad}. `,
            e,
            'notification',
            'error'
          )
        })
    },
    loadData() {
      let toLoad = this.availableRoutesTable[this.itemType]
      this.refreshData(toLoad)
    },
    closeDialog() {
      this.root.dataImporterDialog = false
    }
  }
}
</script>
